import { classNames } from '~/utils/client/helpers'
import Divider from './Divider'

interface TextDividerProps {
  text: string
  className?: string
  textClassName?: string
}

export const TextDivider = ({ text, className, textClassName }: TextDividerProps) => {
  return (
    <Divider className={className}>
      <span className={classNames('bg-white px-2 text-sm text-secondary', textClassName)}>
        {text}
      </span>
    </Divider>
  )
}

export default TextDivider
